<template>
  <div>
    <!-- Job Single Content Starts -->
    <div class="jobSingle-bottom_img" style="position: relative;">
      <img style="width:100%;height:50vh" v-if="solutionlist.position1.length>0" :src="solutionlist.position1[0].thumb" />
      <p v-if="false" style="position: absolute;
              color: #fff;
              bottom: 10vh;
              font-size: 6vh;
              left: 12%;
              border-bottom: 2px solid #ccc;
              font-weight: 600;">{{ solutionlist.position1[0].title }}</p>
    </div>
    <section class="job-single-content section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="main-content">
              <div class="single-content1">
                <div class="single-job mb-4 d-lg-flex justify-content-between" v-if="solutionlist.position2.length>0">
                  <div class="job-text">
                    <h4> {{ solutionlist.position2[0].title }}</h4>
                    <ul class="mt-4">
                      <li class="mb-3">
                        <h5><i class="fa fa-map-marker"></i> {{ solutionlist.position2[0].brief }}</h5>
                      </li>
                      <li>
                        <h5><i class="fa fa-clock-o"></i> 最新发布时间:{{ solutionlist.position2[0].created_at }}</h5>
                      </li>
                    </ul>
                  </div>
                  <div class="job-btn align-self-center" v-if="false">
                    <a href="#" class="forth-btn">联系我吧</a>
                  </div>
                </div>
              </div>
              <div class="single-content4 single-job py-4" v-for="(item, index) in solutionlist.position3" :key="index">
                <h4 class="mobile_title">{{ item.title }}</h4>
                <p></p>
                <ul class="mobile_ul">
                  <li class="mb-2" style="white-space: pre-wrap;">{{ item.brief }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { us } from '@/api/index'
import axios from "axios";

export default {
  data() {
    return {
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],
      },
    }
  },
  components: {},
  methods: {
    getus(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id='+id)
        .then(res=>{
          let list = res.data.data;

          for (let index = 0; index < list.length; index++) {
            if (list[index].position == 1) {
              this.solutionlist.position1.push(list[index])
            } else if (list[index].position == 2) {
              this.solutionlist.position2.push(list[index])
            } else if (list[index].position == 3) {
              list[index].status1 = false
              this.solutionlist.position3.push(list[index])
            } else if (list[index].position == 4) {
              this.solutionlist.position4.push(list[index])
            }
          }
        })
    },
  },
  mounted() {
    this.getus(this.$route.query.id)
  },
}
</script>
<style scoped>
@media (min-width: 280px) {
  .job-text>h4{
    font-size: 2.5vh;
  }
  .mobile_title {
    width: 100%;
    text-align: center;

  }

  .mobile_ul {
    padding-left: 0px;
  }

  .mobile_ul>li {
    list-style: none;
  }

  .jobSingle-bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/shouye_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
}

@media (min-width: 1200px) {
  .mobile_title {
    width: 100%;
    text-align: left !important;
  }
  .mobile_ul {
    padding-left: 30px;
  }

  .jobSingle-bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/shouye_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
}
</style>



// WEBPACK FOOTER //
// JobSingle.vue?5f41ad60